<template>
	<div>
		<v-tooltip v-if="$store.get('isSkilled', 'importance')" top>
			<v-chip
				slot="activator"
				:color="importanceColor"
				small
				class="chip-cursor white--text"
				@click="showImportance"
			>
				{{ article.important }}
			</v-chip>
			Set Importance
		</v-tooltip>
		<v-tooltip v-else top>
			<v-btn
				slot="activator"
				:class="importanceClass"
				small
				icon
				@click="setBasicImportance"
			>
				<v-icon>fa fa-thumb-tack</v-icon>
			</v-btn>
			<span v-if="article.important === 100">Mark as Important</span>
			<span v-else>Unmark as Important</span>
		</v-tooltip>
		<v-menu
			v-model="show"
			v-if="$store.get('isSkilled', 'importance') && !report.isArchivedOrParentArchived"
			left
			style="position: relative;"
		>
			<template slot="activator">
				<div class="importance-activator ma-1" />
			</template>
			<v-card>
				<v-card-text class="px-0 py-2">
					<div class="importance-btns">
						<v-btn icon :disabled="article.important <= 1" @click="setMax">
							<v-icon>fa fa-angle-double-up</v-icon>
						</v-btn>
						<v-btn icon :disabled="article.important <= 1" @click="increment">
							<v-icon>fa fa-angle-up</v-icon>
						</v-btn>
						<v-menu :z-index="600" max-height="300" open-on-hover offset-y nudge-left="3">
							<v-btn
								slot="activator"
								flat
								class="title"
							>
								{{ article.important }}
							</v-btn>
							<v-list v-if="show">
								<v-list-tile
									v-for="number in 200"
									:key="number"
									@click="setImportance(number)"
								>
									<v-list-tile-title>{{ number }}</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
						<v-btn icon :disabled="article.important === 200" @click="decrement">
							<v-icon>fa fa-angle-down</v-icon>
						</v-btn>
						<v-btn icon :disabled="article.important === 200" @click="setZero">
							<v-icon>fa fa-angle-double-down</v-icon>
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
export default {
	props: {
		article: { type: Object, default: null },
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		articles() {
			return this.$store.get('articles');
		},
		report() {
			return this.$store.get('reports/currentReport');
		},
		importanceClass() {
			if (this.article.important < 100) {
				return 'secondary--text rotate-45';
			}
			if (this.article.important > 100) {
				return 'orange--text rotate-45';
			}
			return 'grey--text';
		},
		importanceColor() {
			if (this.article.important < 100) {
				return 'green';
			}
			if (this.article.important > 100) {
				return 'orange';
			}
			return 'grey';
		},
	},
	methods: {
		save() {
			this.article.save().then(() => {
				this.$notify('success', 'Article importance updated.');
			}).catch(() => {
				this.$notify('error', 'Failed to update article importance');
			});
		},
		setImportance(number) {
			this.article.important = number;
			this.show = false;
			this.save();
		},
		showImportance() {
			if (this.report.isArchivedOrParentArchived) {
				this.articleArchived();
				return;
			}
			this.show = !this.show;
		},
		setBasicImportance() {
			if (this.report.isArchivedOrParentArchived) {
				this.articleArchived();
				return;
			}
			if (this.article.important !== 100) {
				this.article.important = 100;
			}
			else {
				this.article.important = 1;
			}
			this.save();
		},
		increment() {
			this.article.important--;
			this.save();
		},
		decrement() {
			this.article.important++;
			this.save();
		},
		setZero() {
			this.article.important = 100;
			this.save();
		},
		setMax() {
			this.article.important = 1;
			this.save();
		},
		articleArchived() {
			this.$notify('error', 'Cannot change archived article importance.');
		},
	},
};
</script>

<style lang="scss" scoped>
.importance-btns {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	.v-btn.title {
		min-width: 68px;
	}
}
.rotate-45 {
	transform: rotate(45deg);
}
.chip-cursor {
	cursor: pointer;
	::v-deep .v-chip__content {
		cursor: pointer;
	}
}
.importance-activator {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
